import { useSearchPageQuery } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/__internal__/useSearchPageQuery";
export var useSearchPageQuerySpellCheckResponse = function() {
    var _useSearchPageQuery_data;
    return (_useSearchPageQuery_data = useSearchPageQuery().data) === null || _useSearchPageQuery_data === void 0 ? void 0 : _useSearchPageQuery_data.query_spell_check_response;
};
